import React, { useRef, useState } from 'react';
import { ReactSearchAutocomplete } from 'react-search-autocomplete';
import { useText } from '@src/components/Text';
import styled from 'styled-components';
import searchItems from '@src/data/searchData';
import searchAdminItems from '@src/data/searchAdminData';
import IconSearch from '@src/assets/icons/icon-search.svg';
import IconDelete from '@src/assets/icons/icon-delete.svg';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

const SearchWrapper = styled.div`
  display: flex;
  position: relative;
  width: 90%;
  height: 60px;
  @media (max-width: 992px) {
    height: 40px;
  }
  #search-icon {
    position: absolute;
    z-index: 100;
    margin: 23px 26px;
    width: 20px;
    height: 20px;
  }
  #delete-icon {
    position: absolute;
    z-index: 100;
    right: 0;
    cursor: pointer;
    margin: 23px 26px;
    width: 20px;
    height: 20px;
  }
  & > div {
    width: 100%;
  }
  *::-webkit-scrollbar {
    width: 19px;
  }
  *::-webkit-scrollbar-track {
    background: #dee2e6;
  }
  ::-webkit-scrollbar-track {
    background: #dee2e6;
    margin-top: -10px;
    border-radius: 100vw;
  }

  *::-webkit-scrollbar-thumb {
    background: #6b7789;
    border: 4.5px #dee2e6 solid;
    border-radius: 10px;
  }
  svg {
    min-width: 35px;
    height: 100%;
  }
  div > input {
    padding-left: 64px;
  }
  input {
    padding: 0;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: normal;
    color: #162056;
    text-decoration: solid;
    ::placeholder {
      font-family: UbuntuMedium, sans-serif;
      font-size: 14px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      color: #cbd2dd;
    }
  }
  ul {
    padding: 11.5px 0;
    max-height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
    li {
      .item {
        display: flex;
        justify-content: space-between;
        padding: 0 26px;
        font-family: UbuntuMedium, sans-serif;
        font-size: 14px;
        font-weight: 300;
        font-stretch: normal;
        font-style: normal;
        line-height: 2.86;
        letter-spacing: normal;
        color: #151e57;
        cursor: pointer;
        .boldFont {
          font-weight: 500;
        }
        .category {
          font-size: 14px;
          font-weight: 500;
          font-stretch: normal;
          font-style: normal;
          line-height: 2.86;
          letter-spacing: normal;
          text-align: right;
          color: #929ca9;
        }
      }
      height: 40px;
      svg {
        display: none;
      }
      .ellipsis {
        overflow: inherit;
        font-size: 14px;
        font-weight: 300;
        font-stretch: normal;
        font-style: normal;
        line-height: 2;
        letter-spacing: normal;
        color: #151e57;
      }
    }
  }
`;

export const FormatResult = ({ item, searchText }) => {
    return [item].map((value) => {
        const boldResultPart = (result, query) => {
            let re = new RegExp(query, 'ig');
            let results = result.replace(/- /g, '').replace(/\./g, '').split(re);
            return [results, [...result.matchAll(re)].map((x) => x[0])];
        };
        const [resultSplit, resultFind] = boldResultPart(value.name, searchText);
        const makeBold = (q) => (
            <strong className="boldFont">
                <b>{q}</b>
            </strong>
        );
        const bolded = resultSplit.map((i, c) =>
                c ? (
                    <span>
          {makeBold(resultFind[c - 1])}
                        {i}
        </span>
                ) : (
                    i
                ),
        );
        return (
            <div className={'item'}>
                <span>{bolded}</span>
                <span className={'category'}>{item.category}</span>
            </div>
        );
    });
};

function CustomSearch(props) {
    const searchRef = useRef();
    const [searchText, setSearchText] = useState('');
    const [searchedResult, setSearchedResult] = useState([]);
    const history = useHistory();
    const { isAdmin } = useSelector((state) => state?.auth);
    let SearchItems = searchItems;
    if (isAdmin) {
        SearchItems = searchAdminItems;
    }

    const handleOnSearch = (string, results) => {
        if (props.onSearchFn) {
            props.onSearchFn(string, results);
        }
        setSearchText(string);
        setSearchedResult(results);
    };

    const handleOnSelect = (item) => {
        setTimeout(() => {
            setSearchText('');
        }, 500);
        history.push(item.url);
    };

    const handleOnFocus = () => {};

    const onCancel = () => {
        if (props.onCancelFn) {
            props.onCancelFn('');
        }
        setSearchText('');
    };

    return (
        <SearchWrapper ref={searchRef}>
            <img id={'search-icon'} src={IconSearch} />
            <ReactSearchAutocomplete
                fuseOptions={{
                    fieldNormWeight: 2,
                    distance: 1000,
                    keys: ['searchText'],
                }}
                autoFocus={true}
                items={SearchItems}
                onSearch={handleOnSearch}
                onSelect={handleOnSelect}
                onFocus={handleOnFocus}
                inputSearchString={searchText}
                formatResult={(item) => <FormatResult item={item} searchText={searchText} />}
                placeholder={useText('howCanHelpInput')}
                showNoResultsText={useText('noResultsFound')}
                showIcon={false}
                showClear={false}
                maxResults={15}
                styling={{
                    height: '64px',
                    border: 'solid 1px #c4c7d4;',
                    borderRadius: '5px',
                    backgroundColor: 'white',
                    boxShadow: 'rgba(32, 33, 36, 0.28) 0px 1px 6px 0px',
                    hoverBackgroundColor: '#eee',
                    color: '#212121',
                    fontSize: '16px',
                    fontFamily: 'UbuntuLight, sans-serif',
                    iconColor: 'grey',
                    lineColor: '#c4c7d4',
                    placeholderColor: 'grey',
                }}
                {...props}
            />
            {searchText && <img id={'delete-icon'} src={IconDelete} onClick={onCancel} />}
        </SearchWrapper>
    );
}

export default CustomSearch;
